module.exports = "/_next/static/images/TrialToPaidConversionDesktop-72a966eec4d280f9e5ae2cc27b4619dc.webp";